// --------------------------------------------------------
// CRIAR AGENDA HEADER - CriarAgendaHeader
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { Avatar } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Colors from '../../constants/Colors'
import { Paths } from '../../enums/Paths'
import { getDescricaoByCodigo } from '../../enums/Roles'
import useFetchPhoto from '../../hooks/useFetchPhoto'
import useResponsiveInfo from '../../hooks/useResponsiveInfo'
import ErrorArea from '../error/ErrorArea'
import { GenericSolidButton } from '../UI/buttons/Button.styled'
import { H1, Text } from '../UI/generalLayout/Layout.styled'
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// CRIAR AGENDA HEADER INTERFACE
// --------------------------------------------------------

interface ICriarAgendaHeader {
    nome: string;
    agenda: any;
    hasRightButton?: boolean;
    errors?: any[];
    onCloseError?: ()=>void;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const CriarAgendaHeader = ({ nome, agenda, hasRightButton = true, errors = [], onCloseError = ()=>{} }: ICriarAgendaHeader) => {
    // --------------------------------------------------------
    // CRIAR AGENDA HEADER PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const  { isMobile } = useResponsiveInfo()
    const [photo, setPhoto] = useState<any>(null)
    const navigate = useNavigate()

    useFetchPhoto(agenda.foto, setPhoto)
    
    const navigateToCreateAgenda = ()=>{
        return navigate(Paths.CriarAgenda, { state: { nomeProfissional: nome, agenda: agenda }})
    }
    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <div style={{ flexDirection: isMobile? 'column':'row', display: 'flex', paddingRight: isMobile? 10 : 0, paddingLeft: isMobile? 10:0, justifyContent: isMobile ? '' : 'space-between', marginBottom: isMobile ? '5%' : '2%', marginTop: 20 }}> {/*Header */}
                <div style={{ flexDirection: 'row', display: 'flex' }}>
                    <Avatar sx={{ width: 70, height: 70 }} src={photo}/>
                    <div style={{ marginLeft: 10, marginTop: -8 }}>
                        <H1>{nome}</H1>
                        <Text style={{ marginTop: -10, fontSize: 14 }}>{getDescricaoByCodigo(agenda.perfilSaude)}</Text>
                    </div>
                </div>
                {hasRightButton && (<div>
                    <GenericSolidButton color={Colors.SPM600} onClick={navigateToCreateAgenda}>Criar agenda</GenericSolidButton>
                </div>)}
            </div>
            <div style={{ marginBottom: 20 }}>
                <ErrorArea errorList={errors} onCloseAction={onCloseError} />
            </div>
        </>
    )
    // --------------------------------------------------------
}

export default CriarAgendaHeader